<script setup lang="ts">
import type { KjdsListPageProps } from '@/types/appTypes'

const props = withDefaults(defineProps<KjdsListPageProps>(), {})

console.log('article: kjdsPageConfig', props.kjdsPageConfig)

const app = useNuxtApp()
const storeArticleList = useStoreArticleList()
const storeIndex = useStoreIndex()

const baseTitle = 'ご招待券プレゼント'
const headTitle = baseTitle

const pageData = {
  tags: [] as ArticleTag[],
  items: [] as Article[],
  meta: {} as ApiMeta,
}

const setHead = () => {
  let headDescription = ''
  let items = []
  headDescription = `展覧会の招待券プレゼントページ。全国で開催されるおすすめ展覧会のチケットを毎日プレゼント中。美術館や博物館に行きたいなら、アイエム［インターネットミュージアム］で！`
  items = [
    {
      text: baseTitle,
      disabled: false,
      to: { path: '/present' },
    },
  ]
  storeIndex.setBreadCrumbs(items)

  const headInput = app.$makeMeta({
    title: headTitle,
    description: headDescription,
  })
  useHead(headInput)
}

const initPage = async () => {
  const options: KjdsFetchListOptions = { query: { ...useRoute().query } }
  const [resSite, resMaster, resList] = await Promise.all([
    storeIndex.fetchSite(),
    storeIndex.fetchMaster(),
    storeArticleList.fetchList(props.kjdsPageConfig.list.mainListName, options),
  ])
  pageData.items = resList.data.articles as Article[]
  pageData.meta = resList.meta

  console.log('article: initPage', pageData)
}
await initPage()
setHead()
</script>

<template>
  <div class="p-articlePage">
    <h2 class="c-heading_page">
      ご招待券プレゼント
    </h2>

    <div class="p-articlePage_result">
      <div class="p-articlePage_list c-detail">
        <div
          v-for="(item, index) in pageData.items"
          v-bind:key="index"
          class="c-detail-item"
        >
          <v-divider
            v-if="index != 0"
            class="c-detail-item-divider"
          />
          <div
            v-if="index != 0"
            class="c-detail-item-divider-sp"
          />
          <PresentItem
            v-bind:key="item.id"
            v-bind:item="item"
          />
        </div>
      </div>

      <Pagination
        v-bind:page="pageData.meta.page_no"
        v-bind:length="pageData.meta.total_page"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use "@/assets/css/foundation/mixin/responsive" as *;

.l-mainContent {
  @include mq_down(sp) {
    padding: 0 var(--g_guide_margin_sp);
  }
}

.c-detail {
  margin-top: 40px;

  &-item {
    width: 100%;

    &-divider {
      margin-top: 30px;
      margin-bottom: 30px;

      @include mq_down(sp) {
        display: none;
      }
    }

    &-divider-sp {
      margin-top: 30px;
      margin-bottom: 30px;

      @include mq_up(pc) {
        display: none;
      }
    }
  }
}
</style>
